import React from "react"
import { useLegendData } from "./constants/legendData"
import LegendItem from "./LegendItem"

const EventColorKey = () => {
  const { eventColorData } = useLegendData()

  return (
    <div className="legend-container">
      <h6 className="mb-2">Event color key</h6>
      <ul className="list-unstyled mb-0">
        {eventColorData.map((item, index) => (
          <LegendItem key={index} iconColor={item.iconColor} label={item.label} />
        ))}
      </ul>
    </div>
  )
}

export default EventColorKey
